import { StepName } from './stepNames';

const stepPriority: Readonly<Record<StepName, number>> = {
  [StepName.Initial]: 0,
  [StepName.ClientType]: 10,
  [StepName.MainCareer]: 20,
  [StepName.Welcome]: 30,
  [StepName.Location]: 40,
  [StepName.Acquaintance]: 60,
  [StepName.Tariff]: 70,
  [StepName.AfterAll]: 100,
};

export const compareSteps = (a: StepName, b: StepName) => {
  const A = stepPriority[a] || 0;
  const B = stepPriority[b] || 0;
  return A - B;
};
